import { PROFILE_FIELDS, createLoginController } from "./access.js";
import { getSupabase } from "./supabase.js";

function setFeedback(element, message, isError = false) {
  element.textContent = message;
  element.classList.toggle("is-error", isError);
}

function validateForm(form) {
  let firstInvalid;
  form.querySelectorAll("input").forEach((input) => {
    const field = input.closest(".f-field");
    const invalid = input.willValidate && !input.checkValidity();
    field?.classList.toggle("has-error", invalid);
    if (invalid && !firstInvalid) firstInvalid = input;
  });
  firstInvalid?.focus();
  return !firstInvalid;
}

export function mountLogin({ document: documentRef = document, auth, profiles, navigate = (destination) => { window.location.href = destination; } } = {}) {
  const form = documentRef.getElementById("loginForm");
  if (!form) return null;

  const client = auth && profiles ? null : getSupabase();
  auth ||= client.auth;
  profiles ||= client;

  const button = documentRef.getElementById("btnLogin");
  const feedback = documentRef.getElementById("loginFeedback");
  const controller = createLoginController({
    signIn: async (credentials) => {
      const { data, error } = await auth.signInWithPassword(credentials);
      if (error) throw new Error("E-mail ou senha inválidos.");
      return data;
    },
    getProfile: async (userId) => {
      const { data, error } = await profiles.from("app_users").select(PROFILE_FIELDS).eq("id", userId).single();
      if (error) throw new Error("Usuário sem perfil de acesso.");
      return data;
    },
    signOut: (options) => auth.signOut(options),
    navigate,
  });

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!validateForm(form)) return;

    button.disabled = true;
    setFeedback(feedback, "Verificando suas credenciais.");
    try {
      await controller.submit({
        email: form.elements.email.value,
        password: form.elements.password.value,
      });
    } catch (error) {
      button.disabled = false;
      setFeedback(feedback, error.message || "Não foi possível entrar agora.", true);
    }
  });

  form.addEventListener("input", (event) => event.target.closest(".f-field")?.classList.remove("has-error"));
  return controller;
}

if (typeof document !== "undefined") mountLogin();
